import { render, staticRenderFns } from "./BankTransferPanel.vue?vue&type=template&id=4051b7fc&scoped=true"
import script from "./BankTransferPanel.vue?vue&type=script&lang=js"
export * from "./BankTransferPanel.vue?vue&type=script&lang=js"
import style0 from "./BankTransferPanel.vue?vue&type=style&index=0&id=4051b7fc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4051b7fc",
  null
  
)

export default component.exports